var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.partitionList)?_c('table',[_c('caption',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._m(0),_c('tbody',_vm._l((_vm.partitionList),function(partition){return _c('tr',{key:partition.key},[_c('td',[_vm._v(_vm._s(partition.ownerHostName))]),_c('td',[_vm._v(_vm._s(partition.key))])])}),0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('th',[_vm._v("Host name")]),_c('th',[_vm._v("Partition")])])
}]

export { render, staticRenderFns }